import { GalleryQuickVote } from "./JudgingInterfaces";

export const MULTIVARIABLE_ROUND_NAME = "Multivariable Judging";

export const isMultivariableRound = (roundType?: string | null) =>
	roundType === MULTIVARIABLE_ROUND_NAME;

export const isScoreRound = (roundType?: string | null) =>
	roundType === "1-10" || isMultivariableRound(roundType);

export const hasSubmittedVote = (vote?: GalleryQuickVote | null) =>
	Boolean(
		vote &&
			(vote.hasSubmittedVote ??
				(
					(vote.voteOptionId !== null && vote.voteOptionId !== undefined) ||
					(vote.compositeScore !== null && vote.compositeScore !== undefined)
				))
	);

export const isAbstainedVote = (vote?: GalleryQuickVote | null) =>
	Boolean(vote && (vote.isAbstained || vote.voteOption?.name === "Abstain"));

export const isPartiallyScoredVote = (vote?: GalleryQuickVote | null) =>
	Boolean(
		vote &&
			!hasSubmittedVote(vote) &&
			vote.criterionScores &&
			vote.criterionScores.some((score) => score.score > 0)
	);

export const formatJudgingScore = (score?: number | null) => {
	if (score === null || score === undefined) {
		return null;
	}

	return score.toFixed(2).replace(/\.?0+$/, "");
};

export const getVoteDisplayLabel = (
	vote?: GalleryQuickVote | null,
	roundType?: string | null
) => {
	if (!vote) {
		return null;
	}

	if (isMultivariableRound(roundType)) {
		if (isAbstainedVote(vote)) {
			return "Abstain";
		}

		return formatJudgingScore(vote.compositeScore);
	}

	if (!vote.voteOption) {
		return null;
	}

	const isGrandRound = vote.voteOption.roundTypeId === 4;
	const isWinnerRound = vote.voteOption.roundTypeId === 5;

	if (isGrandRound || isWinnerRound) {
		return vote.voteOption.name === "Grand" || vote.voteOption.name === "Winner"
			? vote.voteOption.name
			: "X";
	}

	return vote.voteOption.name;
};

export const getVoteColorName = (vote?: GalleryQuickVote | null) => {
	if (!vote) {
		return "Unvoted";
	}

	if (vote.compositeScore !== null && vote.compositeScore !== undefined) {
		return String(Math.min(10, Math.max(1, Math.round(vote.compositeScore))));
	}

	return vote.voteOption?.name || "Unvoted";
};
